import { useFormikContext } from "formik";
import { userFullName } from "helpers/common";
import { Col, Row } from "react-bootstrap";

const ChatterGuardianDetailList = ({ index, guardian, slug, previewMode, clientType = '' }) => {
  const { setFieldValue, values } = useFormikContext()

  const title = slug;
  const data = null
  return (
    <>
      <Row className="px-2">
        <div className="guardian-section" style={{ padding: "0 0 0 4px" }}>

          <div>
            <Col lg={12}>
              <div className="">
                <div className="d-flex reports-guardian discharge-title gap-2">
                  <input
                    type="checkbox"
                    className="form-check"
                    style={{ accentColor: "#b46c9f", height: 20, width: 20, marginTop: "-3px" }}
                    disabled={previewMode}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      let role = ""
                      if (slug == 'parent') {
                        role = index === 0 ? "parent1" : "parent2";
                      }
                      else {
                        role = slug;
                      }
                      const guardianData = { id: guardian?.client_guardian?.id, role };

                      const currentList = values.guardianList || [];

                      let updatedList;
                      if (isChecked) {
                        updatedList = [...currentList, guardianData];
                      } else {
                        updatedList = currentList.filter((item) => item.id !== guardian?.client_guardian?.id);
                      }

                      setFieldValue('guardianList', updatedList);
                    }}
                    checked={values.guardianList?.some((item) => item.id === guardian?.client_guardian?.id)}
                  />
                  <div className="w-100">
                    <div className="reports-guardian-title" style={{ textTransform: "uppercase" }}>
                      {title}
                    </div>
                    <div className="mb-3 mt-2 d-flex align-items-center" style={{ gap: "20px" }}>
                      <div style={{ width: "20%" }}>
                        <label className="discharge-screen-label">Last Name</label>
                        <input className="readonly-box" readOnly value={guardian?.client_guardian?.lastname} />
                      </div>
                      <div style={{ width: "20%" }}>
                        <label className="discharge-screen-label">First Name</label>
                        {/* <div className="readonly-box">{guardian?.client_guardian?.firstname}</div> */}
                        <input className="readonly-box" readOnly value={guardian?.client_guardian?.firstname} />
                      </div>
                      <div style={{ width: "33.5%" }}>
                        <label className="discharge-screen-label">Email</label>
                        {/* <div className="readonly-box">{guardian?.client_guardian?.email}</div> */}
                        <input className="readonly-box" readOnly value={guardian?.client_guardian?.email} />
                      </div>
                      {/* <Col md={3}>
              <label>City/Town</label>
              <div className="readonly-box">{guardian?.client_guardian?.city}</div>
            </Col> */}
                    </div>
                  </div>
                </div>
                {/* <div className="d-flex gap-2 align-items-center">
                  <input
                    type="checkbox"
                    className=""
                  onChange={() => handleSelectClient(item?.id)}
                  checked={selectedClients === item?.id}
                  />
                  <h6 className="m-0 fw-sbold">{item?.lastname || ""}</h6>
                  {title} {"Present"}
                </div> */}
              </div>
            </Col>
          </div>

        </div>
        {/* <Col md="6" className="py-2">
                    <div className="d-flex align-items-start gap-10 flex-wrap">
                        <h6
                            className="m-0 fw-sbold themeBlue"
                            style={{
                                minWidth: 200,
                                fontSize: 14,
                            }}
                        >
                            {title} {index + 1}
                        </h6>
                    </div>
                </Col> */}
      </Row>
      {/* <Row key={index} className="border-bottom p-2 pt-0">
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Last Name:
            </h6>
            <p className="m-0 themeBlue">
              {guardian?.client_guardian?.lastname}
            </p>
          </div>
        </Col>
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              First Name:
            </h6>
            <p className="m-0 themeBlue">
              {guardian?.client_guardian?.firstname}

            </p>
          </div>
        </Col>
        <Col md="6" className="py-2">
          <div className="d-flex align-items-start gap-10 flex-wrap">
            <h6
              className="m-0 fw-sbold themeBlue"
              style={{
                minWidth: 200,
                fontSize: 14,
              }}
            >
              Email:
            </h6>
            <p className="m-0 themeBlue">
              {
                guardian?.client_guardian
                  ?.email
              }
            </p>
          </div>
        </Col>
      </Row> */}
    </>
  )
}

export default ChatterGuardianDetailList;